import React, { useRef } from 'react';
import ReactQuill from 'react-quill';
import style from './style.module.css';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    [{ size: ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline', 'strike'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    [{ align: [] }],
    ['link', 'image'],
    [{ color: [] }, { background: [] }],
    ['clean'],
  ],
};
interface TextEditorProps {
  value: string;
  onChange?: (value: any, empty?: boolean) => void;
  visualizacao?: boolean;
  isDisabled?: boolean;
  styles?: React.CSSProperties;
}

export const TextEditor: React.VFC<TextEditorProps> = ({
  value,
  onChange,
  visualizacao = false,
  isDisabled = false,
  styles = {},
  ...props
}) => {
  const quill = useRef<ReactQuill>(null);

  return (
    <div data-text-editor="name">
      <ReactQuill
        ref={quill}
        theme={visualizacao ? 'bubble' : 'snow'}
        value={value}
        onChange={e => {
          const editor = quill.current?.getEditor();
          onChange ? onChange(e, !editor?.getText().trim()) : undefined;
        }}
        modules={modules}
        className={style.quill}
        style={styles}
        {...props}
        readOnly={visualizacao || isDisabled}
        bounds={`[data-text-editor="name"]`}
      />
    </div>
  );
};
